// Define the function for initializing the Swiper
function productSwiperMobile() {
    // Check if Swiper is available
    if (typeof Swiper === 'undefined') {
        return;
    }

    const swipers = document.querySelectorAll('.mobile-card-swiper');
    
    swipers.forEach(swiperEl => {
        // Skip if already initialized
        if (swiperEl.swiper) {
            return;
        }

        
        // Get product ID from the swiper element
        const productId = swiperEl.id.replace('mobile-swiper-', '');
        if (!productId) {
            console.error('Invalid swiper ID format:', swiperEl.id);
            return;
        }
        
        const paginationId = `swiper-pagination-${productId}`;
        const paginationEl = document.getElementById(paginationId);
        
        if (!paginationEl) {
            console.error('Pagination element not found:', paginationId);
            return;
        }

        try {
            const swiper = new Swiper(swiperEl, {
                loop: false,
                watchSlidesProgress: true,
                pagination: {
                    el: paginationEl,
                    clickable: true,
                    bulletClass: 'swiper-pagination-bullet',
                    bulletActiveClass: 'swiper-pagination-bullet-active',
                    type: 'bullets',
                    renderBullet: function (index, className) {
                        return '<span class="' + className + '"></span>';
                    }
                },
                slidesPerView: 1,
                spaceBetween: 10,
                observer: true,
                observeParents: true,
                on: {
                    slideChange: function () {
                        // Force pagination update on slide change
                        this.pagination.render();
                        this.pagination.update();
                    }
                }
            });
            console.log('Swiper initialized successfully:', swiper);
        } catch (error) {
            console.error('Error initializing swiper:', error);
        }
    });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', productSwiperMobile);
} else {
    productSwiperMobile();
}

// Also initialize when the page is fully loaded
window.addEventListener('load', productSwiperMobile);

// Make the function available globally
window.initializeProductSwiper = productSwiperMobile;
